import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_STATIONS } from "../../../API/UserApi";
import apiHeader from "../../../Components/ApiHeader";

export const getStationViewByIdApi: any = createAsyncThunk(
  "getStationViewById",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(CHARGING_STATIONS + "/" + rowId, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: { isMobile: false },
      });
      return { user: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
